import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleOff, WifiOff, Calculator } from 'lucide-react';
// Copywriting Letal B2B (Enfocado en el dolor real de Venezuela)
const painPoints = [{
  icon: MessageCircleOff,
  title: 'El clásico "Precio" y te ignoran',
  description: 'Te pasas el día respondiendo mensajes, les das el monto en dólares o al cambio, y automáticamente desaparecen. Sientes que estás rogando por ventas.'
}, {
  icon: WifiOff,
  title: 'Apagones y falta de tiempo',
  description: 'Se va la luz o falla el internet y te quedas sin publicar. Necesitas un sistema que te permita diseñar y publicar rápido, directo desde el celular con tus megas.'
}, {
  icon: Calculator,
  title: 'Perdiendo plata por la tasa',
  description: 'Con la fluctuación del BCV, si no tienes tus costos claros en dólares y no calculas rápido al cobrar en Bolívares, terminas perdiendo toda tu ganancia.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function PainPoints() {
  return <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto relative" data-id="element-225">
      {/* Brillo sutil rojo/rosa de fondo para denotar el "Dolor" */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] md:w-[800px] h-[300px] bg-rose-500/5 rounded-full blur-[80px] md:blur-[100px] pointer-events-none" data-id="element-226" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="text-center mb-16 relative z-10" data-id="element-227">
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-rose-500/10 border border-rose-500/20 text-rose-400 text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-228">
          🚨 La cruda realidad del negocio venezolano
        </div>
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white leading-tight max-w-3xl mx-auto" data-id="element-229">
          Si esto es lo que vives a diario,{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-400 to-red-500" data-id="element-230">
            estás perdiendo dinero...
          </span>
        </h2>
      </motion.div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.2
    }} className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 relative z-10" data-id="element-231">
        {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="group relative bg-[#0a0a0a] border border-white/5 rounded-3xl p-8 hover:border-rose-500/30 transition-all duration-500 overflow-hidden" data-id="element-232">
            <div className="absolute inset-0 bg-gradient-to-br from-rose-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-233" />

            <div className="relative z-10" data-id="element-234">
              <div className="w-16 h-16 bg-rose-500/10 rounded-2xl flex items-center justify-center mb-6 border border-rose-500/20 group-hover:scale-110 group-hover:bg-rose-500/20 transition-all duration-300" data-id="element-235">
                <point.icon className="w-8 h-8 text-rose-400" data-id="element-236" />
              </div>
              <h3 className="font-heading text-2xl font-bold text-white mb-4 tracking-tight" data-id="element-237">
                {point.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-lg" data-id="element-238">
                {point.description}
              </p>
            </div>
          </motion.div>)}
      </motion.div>
    </section>;
}